import React from 'react';
import {LeftOutlined, RightOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import classes from '../courses.module.css';

/**
 * Пагинация каталога: по шесть программ на страницу.
 *
 * Своя, а не antd Pagination — у той свой шрифт и синий #1677ff, который
 * не совпадает с фирменным #163269, и перекрывать её стили вышло бы длиннее.
 */
const Pagination = ({page, totalPages, onChange, total, pageSize}) => {
    const {t} = useTranslation();
    if (totalPages <= 1) return null;

    // При 12 курсах страниц две-три, поэтому показываем их все без сокращений.
    // Многоточие оставлено на случай, когда программ станет заметно больше.
    const pages = [];
    const spread = 2;
    for (let i = 1; i <= totalPages; i += 1) {
        if (i === 1 || i === totalPages || Math.abs(i - page) <= spread) {
            pages.push(i);
        } else if (pages[pages.length - 1] !== '…') {
            pages.push('…');
        }
    }

    const go = (next) => {
        onChange(next);
        // Возврат к началу списка: иначе вторая страница открывается «с середины»
        if (typeof window !== 'undefined') window.scrollTo({top: 0, behavior: 'smooth'});
    };

    const from = (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, total);

    return (
        <>
            <nav className={classes.pagination} aria-label={t('coursesPage.pagination.label')}>
                <button
                    type="button"
                    className={classes.pageBtn}
                    onClick={() => go(page - 1)}
                    disabled={page === 1}
                    aria-label={t('coursesPage.pagination.prev')}
                >
                    <LeftOutlined/>
                </button>

                {pages.map((p, i) => (
                    p === '…'
                        ? <span key={`gap-${i}`} className={classes.pageDots}>…</span>
                        : (
                            <button
                                key={p}
                                type="button"
                                className={`${classes.pageBtn} ${p === page ? classes.pageBtnActive : ''}`}
                                onClick={() => go(p)}
                                aria-current={p === page ? 'page' : undefined}
                            >
                                {p}
                            </button>
                        )
                ))}

                <button
                    type="button"
                    className={classes.pageBtn}
                    onClick={() => go(page + 1)}
                    disabled={page === totalPages}
                    aria-label={t('coursesPage.pagination.next')}
                >
                    <RightOutlined/>
                </button>
            </nav>
            <div className={classes.pageInfo}>
                {t('coursesPage.pagination.info', {from, to, total})}
            </div>
        </>
    );
};

export default Pagination;
